/* Petifo · lightbox VIDEO — the SOLE owner of the video's size and its
   play/pause. Loaded AFTER pf-zoom-extras.js and pf-zoom-extras-fixes.js.

   ONE OWNER, AND NO POLLING. An earlier version sized the video here every
   600ms while pf-zoom-extras-fixes.js sized it to the full slide every 500ms.
   The two overwrote each other forever: the video visibly pumped between
   1512px and 1361px, and the constant relayout also swallowed the first click
   on the main gallery, so the lightbox needed two taps to open. Sizing now
   happens ONLY on real events — dialog opened, video loaded, slide settled,
   viewport resized — and nothing else writes to it. Do not reintroduce a timer
   here, and do not size the video from any other file.

   1. THE VIDEO MATCHES THE IMAGE BOX, NOT THE SLIDE.
   Image slides render their media inside a padded box — measured 1361x685
   inside a 1512x761 slide. Spanning the video edge to edge made it full-bleed
   while every photo sat inset, so it read as a different, larger surface.
   imageBox() MEASURES a real image slide at runtime and copies that box, so the
   two agree at any viewport instead of hard-coding the padding.
   Positioning trap: the video must be absolute against the SLIDE, so every
   element between them has to be forced to position:static — otherwise a
   relatively positioned ancestor becomes the containing block and the video
   fills the wrong box (it ended up 342px wide, hard against the right edge).

   2. PLAY/PAUSE WITHOUT THE BROWSER'S PLAYER.
   `controls` gives the whole browser player — scrubber, timecode, volume,
   fullscreen, overflow menu — which reads as an embedded video rather than a
   product shot. No controls at all leaves the customer unable to pause. So
   controls stay OFF and ONE overlay button toggles playback, built from the SVG
   cloned out of the theme's own `.deferred-media__poster-button` so the icon is
   Shopify's. Visible while paused, hidden while playing.

   THE CLICK MUST BE REGISTERED IN THE CAPTURE PHASE. pf-zoom-extras.js holds a
   document-level capture listener that calls stopPropagation() for anything
   inside a video, to keep the zoom/swipe gestures off the player. A listener
   bound to the video element itself would never fire. Another document capture
   listener does — stopPropagation() blocks descendants, not other listeners on
   the same node. Do not "simplify" it onto the element.

   pf-zoom-extras-fixes.js hides theme leftovers with `button:not(.pf-zx-play)`,
   so this button is exempt by class name. Keep that class if you rename it. */
(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function dialogEl() { return qs('.dialog-zoomed-gallery__dialog'); }
  function galleryEl() { var d = dialogEl(); return d ? qs('.dialog-zoomed-gallery', d) : null; }
  function isOpen() { var d = dialogEl(); return !!(d && d.hasAttribute('open')); }
  function videoSlides() { return qsa('.dialog-zoomed-gallery .product-media-container--video'); }
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function btnSize() { return isMobile() ? 58 : 68; }

  var CSS_ID = 'pf-zv-css';
  if (!document.getElementById(CSS_ID)) {
    var css = ''
      + '.dialog-zoomed-gallery .product-media-container--video button.pf-zx-play{'
      + 'display:flex!important;position:absolute!important;z-index:6!important;'
      + 'align-items:center!important;justify-content:center!important;'
      + 'width:68px!important;height:68px!important;padding:0!important;'
      + 'border:0!important;border-radius:50%!important;cursor:pointer!important;'
      + 'background:rgba(20,20,20,.55)!important;color:#fff!important;'
      + 'box-shadow:0 2px 14px rgba(0,0,0,.28)!important;'
      + 'opacity:1;transition:opacity .18s ease}'
      + '.dialog-zoomed-gallery .product-media-container--video button.pf-zx-play svg{'
      + 'width:26px!important;height:26px!important;color:#fff!important;fill:#fff!important;'
      + 'stroke:none!important;display:block!important}'
      + '.dialog-zoomed-gallery .product-media-container--video button.pf-zx-play.pf-hidden{'
      + 'opacity:0!important;pointer-events:none!important}'
      + '@media (max-width:749px){.dialog-zoomed-gallery .product-media-container--video button.pf-zx-play{'
      + 'width:58px!important;height:58px!important}'
      + '.dialog-zoomed-gallery .product-media-container--video button.pf-zx-play svg{'
      + 'width:22px!important;height:22px!important}}';
    var st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  /* ---------- 1. size to the image box ---------- */

  function imageBox() {
    var g = galleryEl();
    if (!g) return null;
    var slides = qsa('.product-media-container', g);
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      if (String(s.className).indexOf('--video') > -1) continue;
      var m = s.querySelector('.product-media') || s.querySelector('img');
      if (!m) continue;
      var mr = m.getBoundingClientRect();
      var sr = s.getBoundingClientRect();
      if (!mr.width || !sr.width) continue;
      return {
        top: Math.round(mr.top - sr.top),
        left: Math.round(mr.left - sr.left),
        w: Math.round(mr.width),
        h: Math.round(mr.height)
      };
    }
    return null;
  }

  function sizeToImageBox(slide) {
    var v = slide.querySelector('video') || slide.querySelector('iframe');
    if (!v) return;
    var box = imageBox();
    if (!box || !box.w) return;

    /* Skip if already correct — never write the same value twice. */
    var vr = v.getBoundingClientRect();
    var already = Math.abs(vr.width - box.w) < 2 && Math.abs(vr.height - box.h) < 2;

    if (!already) {
      slide.style.setProperty('position', 'relative', 'important');
      qsa('*', slide).forEach(function (el) {
        if (el === v || el.classList.contains('pf-zx-play')) return;
        if (getComputedStyle(el).position === 'relative') {
          el.style.setProperty('position', 'static', 'important');
        }
      });

      v.style.setProperty('position', 'absolute', 'important');
      v.style.setProperty('top', box.top + 'px', 'important');
      v.style.setProperty('left', box.left + 'px', 'important');
      v.style.setProperty('right', 'auto', 'important');
      v.style.setProperty('bottom', 'auto', 'important');
      v.style.setProperty('width', box.w + 'px', 'important');
      v.style.setProperty('height', box.h + 'px', 'important');
      v.style.setProperty('max-width', 'none', 'important');
      v.style.setProperty('max-height', 'none', 'important');
      v.style.setProperty('object-fit', 'contain', 'important');
      v.style.setProperty('background', 'transparent', 'important');
      v.style.setProperty('margin', '0', 'important');
      v.style.setProperty('transform', 'none', 'important');
    }

    var btn = slide.querySelector('.pf-zx-play');
    if (btn) {
      var half = btnSize() / 2;
      var t = Math.round(box.top + box.h / 2 - half) + 'px';
      var l = Math.round(box.left + box.w / 2 - half) + 'px';
      if (btn.style.top !== t) btn.style.setProperty('top', t, 'important');
      if (btn.style.left !== l) btn.style.setProperty('left', l, 'important');
    }
  }

  /* ---------- 2. play / pause ---------- */

  function themePlayIcon() {
    var src = qs('.deferred-media__poster-button svg');
    if (src) return src.cloneNode(true).outerHTML;
    return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6 4l10 6-10 6z" fill="currentColor"/></svg>';
  }

  var PAUSE_ICON = '<svg viewBox="0 0 20 20" aria-hidden="true">'
    + '<rect x="5" y="4" width="3.4" height="12" rx="1" fill="currentColor"/>'
    + '<rect x="11.6" y="4" width="3.4" height="12" rx="1" fill="currentColor"/></svg>';

  function ensureToggle(slide) {
    var v = slide.querySelector('video');
    if (!v) return null;
    var btn = slide.querySelector('.pf-zx-play');
    if (btn) return btn;

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pf-zx-play';
    btn.setAttribute('aria-label', window.PetifoI18n.common.play);
    btn.innerHTML = themePlayIcon();
    slide.appendChild(btn);

    try {
      new MutationObserver(function () {
        if (btn.style.display === 'none') btn.style.removeProperty('display');
      }).observe(btn, { attributes: true, attributeFilter: ['style'] });
    } catch (e) {}

    function sync() {
      if (v.paused) {
        btn.innerHTML = themePlayIcon();
        btn.setAttribute('aria-label', window.PetifoI18n.common.play);
        btn.classList.remove('pf-hidden');
      } else {
        btn.classList.add('pf-hidden');
        btn.setAttribute('aria-label', window.PetifoI18n.common.pause);
      }
    }
    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);
    v.addEventListener('loadedmetadata', function () { sizeToImageBox(slide); });
    sync();
    return btn;
  }

  function toggle(slide) {
    var v = slide.querySelector('video');
    if (!v) return;
    var btn = slide.querySelector('.pf-zx-play');
    if (v.paused) {
      v.play().catch(function () {});
    } else {
      v.pause();
      if (btn) {
        btn.innerHTML = PAUSE_ICON;
        btn.classList.remove('pf-hidden');
        setTimeout(function () { if (v.paused) btn.innerHTML = themePlayIcon(); }, 280);
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    if (!e.target || !e.target.closest) return;
    var slide = e.target.closest('.product-media-container--video');
    if (!slide) return;
    if (!e.target.closest('video, .pf-zx-play')) return;
    e.preventDefault();
    toggle(slide);
  }, true);

  /* ---------- event-driven upkeep only ---------- */

  function apply() {
    if (!isOpen()) return;
    videoSlides().forEach(function (slide) {
      if (!slide.querySelector('video')) return;
      ensureToggle(slide);
      sizeToImageBox(slide);
    });
  }

  function onOpen() {
    /* a short settle sequence, then nothing until something really changes */
    [350, 900, 1800, 3000].forEach(function (ms) { setTimeout(apply, ms); });
  }

  function watch() {
    var d = dialogEl();
    if (!d || d.getAttribute('data-pf-zv') === '1') return;
    d.setAttribute('data-pf-zv', '1');
    try {
      new MutationObserver(function () {
        if (d.hasAttribute('open')) onOpen();
      }).observe(d, { attributes: true, attributeFilter: ['open'] });
    } catch (e) {}

    var g = qs('.dialog-zoomed-gallery', d);
    if (g && g.getAttribute('data-pf-zv-scroll') !== '1') {
      g.setAttribute('data-pf-zv-scroll', '1');
      var t = null;
      g.addEventListener('scroll', function () {
        if (t) clearTimeout(t);
        t = setTimeout(apply, 220);
      }, { passive: true });
    }

    if (d.hasAttribute('open')) onOpen();
  }

  window.addEventListener('resize', function () { if (isOpen()) apply(); }, { passive: true });

  watch();
  var n = 0;
  var iv = setInterval(function () {
    watch();
    if (++n > 40) clearInterval(iv);
  }, 500);
})();